import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Output,
	EventEmitter
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Auth, AuthState } from './definitions';
import { AuthService } from './auth.service';
import { KngLoaderState } from 'kinetic-angular';
import { LoggerService } from '../../services/logger/logger.service';
import { Icons } from '../../services/shared/shared-enums';

@Component({
	selector: 'tmhna-portal-auth',
	templateUrl: './template/auth.component.html'
})
export class AuthComponent implements Auth, OnInit, OnDestroy 
{
	private subscriptions: Subscription = new Subscription();
	loaderState: KngLoaderState = {
		imagePath: Icons.loaderOrange
	};
  @Input() set state(value: AuthState) 
	{
		this.service.updateState(value);
	}
  get state(): AuthState 
  {
  	return this.service.state;
  }

  @Output() stateChanged: EventEmitter<AuthState> =
  	new EventEmitter<AuthState>();

  constructor(private service: AuthService, private loggerService: LoggerService) {}

  async ngOnInit(): Promise<void> 
  {
  	this.initSubscriptions();
  	try 
  	{
  		await this.service.redirectBasedOnUserRegistrationStatus();
  	}
  	catch (error) 
  	{
  		this.loggerService.log('Error redirecting based on status', error);
  		throw error;
  	}
  }

  private initSubscriptions(): void 
  {
  	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
  		(next: AuthState) => this.stateChanged.emit(next)
  	);
  	this.subscriptions.add(stateChangeSubs);
  }

  private destroySubscriptions(): void 
  {
  	this.subscriptions.unsubscribe();
  }

  ngOnDestroy(): void 
  {
  	this.destroySubscriptions();
  }
}
